import React from "react";
import styled from "styled-components";

interface StyledCheckBoxProps {
  width: string;
  height: string;
}

const StyledCheckBox = styled.input<StyledCheckBoxProps>`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  display: inline-flex;
  padding-top: 2px;
  justify-content: center;
  align-items: center;
  appearance: none;
  border: 2px solid ${(props) => (props.checked ? "#00A603" : "#ccc")};
  border-radius: 4px;
  outline: none;
  position: relative;

  &:checked {
    background-color: #ccf4cd;
    border-color: #00a603;
  }

  &:checked::before {
    content: "";
    width: 40%;
    height: 50%;
    border: solid #00a603;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-45%, -60%) rotate(45deg);
  }
`;

interface CheckBoxProps {
  checked: boolean;
  onChange: (e?: any) => void;
  width?: string;
  height?: string;
}

const CheckBox: React.FC<CheckBoxProps> = ({
  checked,
  onChange,
  width = "16px",
  height = "16px",
}) => {
  return (
    <StyledCheckBox
      type="checkbox"
      checked={checked}
      onChange={onChange}
      width={width}
      height={height}
    />
  );
};

export default CheckBox;
